import React from 'react';
import { Search, Database, FileText, AlertCircle } from 'lucide-react';

interface EmptyStateProps {
  icon?: 'search' | 'data' | 'file' | 'alert';
  title?: string;
  description?: string;
  action?: React.ReactNode;
  variant?: 'empty' | 'error';
}

const iconMap = { search: Search, data: Database, file: FileText, alert: AlertCircle };

export default function EmptyState({
  icon = 'data',
  title,
  description,
  action,
  variant = 'empty',
}: EmptyStateProps) {
  const isError = variant === 'error';

  const resolvedTitle = title ?? (isError ? 'Something went wrong' : 'No data found');
  const resolvedDescription =
    description ??
    (isError
      ? 'Failed to load data. Please try again.'
      : 'There are no records to display at this time.');

  const Icon = isError ? AlertCircle : iconMap[icon];

  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      <div
        className={`w-14 h-14 rounded-2xl flex items-center justify-center mb-4 ${
          isError ? 'bg-red-50' : 'bg-card2'
        }`}
      >
        <Icon size={24} className={isError ? 'text-red-500' : 'text-text-dim'} />
      </div>
      <h3 className="font-serif font-semibold text-base text-text mb-1">{resolvedTitle}</h3>
      <p className="text-sm text-text-muted max-w-xs">{resolvedDescription}</p>
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
